import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import React from "react";
import {formatDateToString, formatToCurrencyType} from "helper/common";
const {INPUT, SELECT, COMBO_BOX, CURRENCY, NUMBER} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 6};
const fields: any[] = [
  {
    type: SELECT,
    label: "Kho kính",
    name: "storeId",
    css: css,
  },
  {
    type: INPUT,
    label: "Mã vật tư",
    name: "code",
    css: css,
  },
  {
    type: INPUT,
    label: "Tên vật tư",
    name: "glassesName",
    css: css,
  },
  {
    type: COMBO_BOX,
    label: "Loại vật tư",
    name: "loaiVatTuId",
    css: css,
  },
];

const columns: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (value, record, index) => index + 1,
    show: true,
    align: "center",
    fixed: "left",
    width: 40,
  },
  // {
  //   title: "Kho",
  //   key: "store",
  //   dataIndex: "store",
  //   show: true,
  //   width: 80,
  // },
  {
    title: "Số lô",
    key: "soLo",
    dataIndex: "soLo",
    show: true,
    align: "left",
    width: 120,
  },

  {
    title: "Mã VT",
    key: "code",
    dataIndex: "code",
    align: "left",
    show: true,
    width: 60,
  },
  {
    title: "Tên vật tư",
    key: "glassesName",
    dataIndex: "glassesName",
    show: true,
    align: "left",
    width: 120,
  },
  {
    title: "ĐV tính",
    key: "donViTinh",
    dataIndex: "donViTinh",
    show: false,
    width: 80,
  },
  {
    title: "Loại vật tư",
    key: "loaiVatTu",
    dataIndex: "loaiVatTu",
    show: false,
    width: 80,
  },
  {
    title: "Vật liệu",
    key: "vatLieu",
    dataIndex: "vatLieu",
    show: false,
    align: "left",
    width: 80,
  },
  {
    title: "Màu sắc",
    key: "mauSac",
    dataIndex: "mauSac",
    show: true,
    align: "left",
    width: 60,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    render(value, record, index) {
      return <>{value == 1 ? "Nam" : "Nữ"}</>;
    },
    show: false,
    align: "left",
    width: 80,
  },
  {
    title: "Kích cỡ",
    key: "kichCo",
    dataIndex: "kichCo",
    show: true,
    align: "left",
    width: 60,
  },
  {
    title: "Hãng sản xuất",
    key: "hangSanXuat",
    dataIndex: "hangSanXuat",
    show: false,
    align: "left",
    width: 80,
  },
  {
    title: "Đặc điểm khác",
    key: "dacDiemKhac",
    dataIndex: "dacDiemKhac",
    show: false,
    align: "left",
    width: 80,
  },
  {
    title: "Ngày nhập về",
    key: "ngayNhapVe",
    dataIndex: "ngayNhapVe",
    show: true,
    align: "left",
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
    width: 90,
  },

  {
    type: CURRENCY,
    title: "Đơn giá nhập",
    key: "donGiaNhap",
    dataIndex: "donGiaNhap",
    show: true,
    align: "right",
    editable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    width: 120,
  },
  {
    type: CURRENCY,
    title: "Đơn giá bán",
    key: "donGiaBan",
    dataIndex: "donGiaBan",
    show: true,
    align: "right",
    editable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    width: 120,
  },
  {
    title: "VAT",
    key: "vat",
    dataIndex: "vat",
    show: true,
    align: "right",
    width: 40,
  },
  {
    title: "Thành tiền",
    key: "thanhTien",
    dataIndex: "thanhTien",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    width: 120,
  },
  {
    title: "Nhà cung cấp",
    key: "nhaCungCap",
    dataIndex: "nhaCungCap",
    show: true,
    align: "left",
    width: 80,
  },
  {
    type: INPUT,
    title: "Ghi chú",
    key: "note",
    dataIndex: "note",
    show: false,
    align: "left",
    editable: true,
    width: 80,
  },

  {
    title: "Số lượng nhập",
    key: "nhapBanDau",
    dataIndex: "nhapBanDau",
    show: false,
    align: "right",
    width: 80,
  },
  {
    title: "Số lượng",
    key: "tonKho",
    dataIndex: "tonKho",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{value > 0 ? value : 0}</>;
    },
    width: 60,
  },
  {
    type: NUMBER,
    title: "SL xuất dự kiến",
    key: "xuatDuKien",
    dataIndex: "xuatDuKien",
    show: true,
    align: "right",
    fixed: "right",
    editable: true,
    width: 60,
  },
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 80,
  },
];

export {fields, columns};
